import useTitle from "../../hooks/useTitle"
import PulseLoader from 'react-spinners/PulseLoader'
import {  useNavigate, useParams } from "react-router-dom"
import { useLazyGetReportsQuery } from './reportsApiSlice'
import { useEffect, useState } from "react"
import ReportsList from './ReportsList'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFileAlt, faPrint, faSearch } from "@fortawesome/free-solid-svg-icons"

function ReportsListFilter() {
    const {groupId} = useParams()
    useTitle('geshtop-Exercise: Reports List')
    const [q,setQ] = useState('')
    const [selectedTasks, setSelectedTasks] = useState([])
    const [ trigger,  {
        data,
        isLoading,
        isSuccess,
        isError,
        error
    } ] = useLazyGetReportsQuery()
   
    useEffect(() => {
        if (isSuccess){
         setSelectedTasks(data.selectedTasks)
        }
    }, [isSuccess])
    
   
    const checkTask = (e)=>{
        const { value, checked } = e.target;
        if(checked) {
            setSelectedTasks([...selectedTasks, value])
        }else{
           setSelectedTasks(selectedTasks.filter(c=>c!==value))
        }
    }
    const navigate = useNavigate()
    const getGrades =()=>{
        if (!isSuccess){
            trigger({groupId})
        }
    }

  
    const content =(<>
    <div className="filter-form">
  
        <div className="filter-form-item">
            <input placeholder="User Id  or Name" className="form__input" onChange={(e)=>setQ(e.target.value)} />
        </div>

     {groupId!=="0"? <> <button className="icon-button" onClick={getGrades}><FontAwesomeIcon   icon={faSearch} />  </button> </>: <p>יש לבחור קבוצה</p> }  
     {isSuccess && <> <button className="icon-button"  onClick={() => window.print()}><FontAwesomeIcon   icon={faPrint} />  </button> </>}  
     {(isSuccess && data?.tasks?.length) && (<>
         <div className="selected-tasks">
            {data.tasks.map(task=>{
             return   <label key={`t${task._id  }`}><span>{task.title}</span><input name={"select"} 
             id={`c${task._id}`} 
             checked={selectedTasks.includes(task._id)}
             onChange={checkTask} value={task._id} type="checkbox"  /> </label>
            })}
        </div>
        </>)}
    </div>
    {isSuccess  &&  <ReportsList q={q} users={data.users} tasks ={data.tasks} selectedTasks={selectedTasks} responses={data.responses} />}
    {isLoading  && <PulseLoader color={"#FFF"} />}
    {isError  && <p className="errmsg">{error?.data?.message}</p>}
</> 
) 
  
      


  return content;
}

export default ReportsListFilter